import { IS_DEV } from '../../viteEnv';
import { EMPTY_OBJ } from '@dadohr/shared/domainTypes/emptyConstants';
import { useEffect, useRef } from 'react';

export type DebugOptions = {
  logOnlyOnChange?: boolean;
  disable?: boolean;
};

export const debuggedShallowEqual = <Props = any>(
  label: string | ((nextProps: Props) => string),
  opts: DebugOptions = EMPTY_OBJ
) => {
  if (IS_DEV) {
    if (opts.disable) {
      return undefined;
    }

    let counter = 0;
    return (prevProps: any, nextProps: any) => {
      const checkField = (field: any) => {
        const prev = (prevProps as any)[field];
        const next = (nextProps as any)[field];
        const eq = next === prev;
        return [eq, prev, next];
      };
      const keys = [
        ...new Set([...Object.keys(nextProps), ...Object.keys(prevProps)])
      ].sort();
      const result = keys.reduce<{
        [field: string]: { eq: boolean; prev: any; next: any };
      }>((m, k) => {
        const [eq, prev, next] = checkField(k);
        m[k] = { eq, prev, next };
        return m;
      }, {});
      const allEqual = Object.values(result).every((r) => r.eq);
      if (!opts.logOnlyOnChange || !allEqual) {
        console.groupCollapsed(
          `${
            typeof label === 'function' ? label(nextProps) : label
          } - ${counter++} - ${allEqual ? 'SKIP' : 'RENDER'}`
        );
        console.table(result);
        console.groupEnd();
      }
      return allEqual;
    };
  } else {
    return undefined;
  }
};

export const useLogOnChange = (label: string, data: any) => {
  const ref = useRef();
  useEffect(() => {
    if (ref.current !== data) {
      console.log(`CHANGE: ${label}`, ref.current, data);
      ref.current = data;
    }
  }, [label, data]);
};
